import React from 'react';
import classNames from 'classnames';
import Grid from '../../../../common/components/Grid/Grid';
import ApplyForm from '../../../../common/components/ApplyForm/ApplyForm';

interface SpecialVacancyProps {
  className?: string;
  opened: boolean;
}

interface PrevProps {
  opened: boolean
}

interface State {
  opened: boolean,
}

class SpecialVacancy extends React.Component<SpecialVacancyProps, State> {

  private currentClass = 'special-vacancy';

  private className?: string;

  constructor(props: SpecialVacancyProps) {
    super(props);
    this.state = {
      opened: this.props.opened,
    }
  }

  componentDidUpdate(prevProps: PrevProps): void {
    if (prevProps.opened !== this.props.opened) {
      this.open();
    }
  }

  onClick = (ev: React.MouseEvent): void => {
    ev.preventDefault();
    ev.stopPropagation();
    this.open();
  }

  private open() {
    const { opened } = this.state;

    if (!opened) {
      this.setState({
        opened: true
      })
    }
  }

  render(): JSX.Element {
    const { opened } = this.state;
    const klass: {[k: string]: boolean} = {
      opened,
      [this.currentClass]: true
    }
    const windowWidth = window.innerWidth;
    let plateGridClass;
    let formGridClass;

    if (this.className) klass[this.className] = true;
    if (windowWidth < 767) {
      plateGridClass = Grid.itemClass(8);
      formGridClass = Grid.itemClass(8);
    } else if (windowWidth >= 768 && windowWidth < 1279) {
      plateGridClass = Grid.itemClass(4);
      formGridClass = Grid.itemClass(8);
    } else if (windowWidth >= 1280) {
      plateGridClass = Grid.itemClass(6);
      formGridClass = Grid.itemClass(10, 1);
    }

    return (
      <div className={classNames(klass)}>
        <Grid className="area-block-body">
          <a
            href="#"
            className={`vacancy vacancy-plate item ${plateGridClass}`}
            onClick={this.onClick}
          >
            <div className="name">Расскажи о своих суперспособностях</div>
            <div className="description">
              Мы что-нибудь придумаем
            </div>
          </a>
        </Grid>
        <div className="form">
          <h4 className="bold apply-from-title">Расскажи о своих суперспособностях — мы что-нибудь придумаем</h4>
          <Grid>
            <ApplyForm id="apply-form" className={formGridClass} />
          </Grid>
        </div>
      </div>
    );
  }
}

export default SpecialVacancy;
